import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-open-line text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50 whitespace-nowrap font-heading">
                韩国漫画网
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              韩国漫画网提供海量正版韩国漫画免费在线阅读，每日同步更新最新章节，无广告畅快阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}韩漫
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">更多分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}韩漫
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  联系我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  用户协议
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  隐私政策
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-400/20 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-background-500">
          <p>&copy; 2026 韩国漫画网 ManHuaWang.cn 版权所有</p>
          <div className="flex items-center gap-4">
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">用户协议</a>
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}